<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HQ3yfc/tc-custom/9781526745507.jpg?1708808694508" alt="This image is the cover for the book Crusaders and Revolutionaries of the Thirteenth Century"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crusaders and Revolutionaries of the Thirteenth Century
      </h1>
      <p class="bookDescription body article font2">
        <b>This family biography charts the rise and fall of the medieval dynasty credited with establishing England’s parliamentary system.</b><br/><br/>Originally from France, the de Montfort family grew to prominence during the 13th century as heroes of the Crusades. Winning lordships around the Mediterranean, they married into the English aristocracy and ascended to an Earlship. Historian Darren Baker explores the family history, dispelling misconceptions and shedding light on its most significant members.<br/><br/>Simon de Montfort, a renowned commander of the Albigensian Crusade against the Cathars in France, ascended to the peerage as the 5th Earl of Leicester. But it is his son and namesake who is perhaps the best known. Simon de Montfort, 6th Earl of Leicester, led the Second Baron’s War against King Henry III and established the first parliamentary state in Europe.<br/><br/>After Simon’s death at Evesham in 1265, the family falls into decline. Their fate is sealed when their role in a vengeful political murder scandalizes Europe. The lineage ends when Eleanor de Montfort, the last Princess of Wales, dies in childbirth and her daughter is raised as a nun.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Darren Baker
      </h2>
      
      <p class="authorDescription body article">Born in California in 1961, Darren Baker took his degree in modern and classical languages at the University of Connecticut. He lives today with his wife and children in in the Czech Republic, where he writes and translates.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25f1635a